import DefaultAvatar from '@iez/features/default-avatar/'
import defaultSrc from './avatar.png'

export default () => {
  DefaultAvatar({ defaultSrc })
}
